import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { processResolver } from '../efaact-routing/process-resolver';
import { LeaveAdjustmentFeatureComponent } from './feature/leave-adjustment-feature.component';

const log = new LoggingService();
export const LeaveAdjustmentRoute: Ng2StateDeclaration = {
    name: 'employeeleave',
    url: '/employeeleave',
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: LeaveAdjustmentFeatureComponent
};
